import { useEffect } from "react";
import Layout from "../../components/layout/Layout";
import { useAppSelector } from "../../context-store";
import { RoleEnum } from "../../models/enums/RoleEnum";
import { Redirect, useHistory } from "react-router";
const Home = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    useEffect(() => {
        if (loggedInUser != null) {
            if (loggedInUser.roleId.toString() === RoleEnum.Interviewer.toString()) {
                history.push("/interviewer-dashboard");
            } else if (loggedInUser.roleId.toString() === RoleEnum.Candidate.toString()) {
                history.push("/candidate-dashboard");
            }
            else if (loggedInUser.roleId.toString() === RoleEnum.ClientAdmin.toString()) {
                history.push("/company-dashboard");
            }
            else if (loggedInUser.roleId.toString() === RoleEnum.ClientRecruiter.toString()) {
                history.push("/recruiter-dashboard");
            }
            else if (loggedInUser.roleId.toString() === RoleEnum.ClientLead.toString()) {
                history.push("/recruiter-dashboard");
            }
            else if (loggedInUser.roleId.toString() === RoleEnum.Vendor.toString()) {
                history.push("/vendor-dashboard");
            }
            else if (loggedInUser.roleId.toString() === RoleEnum.VendorRecruiter.toString()) {
                history.push("/vendor-recruiter-dashboard");
            }
            else if (loggedInUser.roleId.toString() === RoleEnum.Administrator.toString() || loggedInUser.roleId.toString() === RoleEnum.IAIRecruiter.toString() || loggedInUser.roleId.toString() === RoleEnum.PanelManagement.toString() || loggedInUser.roleId.toString() === RoleEnum.IAIAccountManager.toString()) {
                history.push("/admin-dashboard");
            }
        }
    }, [loggedInUser, history]);

    return (
        <Layout>
            <div className="page-title">
                <h4 className="breadcrumb-header">Home</h4>
            </div>
        </Layout>
    );
};
export default Home;